module.exports = __webpack_public_path__ + "img/wtamu.00c04ed1.png";